import React from 'react';
import DENTModalOverviewPeriodontalItem, {
	PeriodontalItemProps,
} from './DENTModalOverviewPeriodontalItem';
// @ts-ignore
import styles from './DENTModalOverviewPeriodontalItemDetail.module.scss';

const DENTModalOverviewPeriodontalItemDetail = (
	props: PeriodontalItemProps,
) => {
	return (
		<div className={styles.wrapper}>
			<DENTModalOverviewPeriodontalItem {...props} />
		</div>
	);
};

export default DENTModalOverviewPeriodontalItemDetail;
